import { useTranslation } from "@coworker/locales";
import { useCustomAllSelectOption } from "@coworker/apprestructured/src/shared/filters/utils/useAllSelectOption";
import {
  FilterType,
  InputType,
} from "@coworker/apprestructured/src/shared/filters/types/filter";

const ROUND_ID = "round";

export function useRoundFilter(showRound: boolean) {
  const { t } = useTranslation();
  const defaultValue = { filterId: ROUND_ID, value: "" };

  return useCustomAllSelectOption(
    {
      inputType: InputType.Select,
      filterType: FilterType.Filter,
      id: ROUND_ID,
      title: t("roundString"),
      options: [
        {
          value: "morningRound",
          title: t("morningRoundString"),
        },
        {
          value: "middayRound",
          title: t("middayRoundString"),
        },
        {
          value: "afternoonRound",
          title: t("afternoonRoundString"),
        },
      ],
      enabled: showRound,
      defaultValue,
    },
    t("allRoundsString")
  );
}
